export default from './NonAuthSurveyPage';



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/index.js